export default {
  "Cut Audio": "ऑडियो काटें",
  "HitPaw Online Audio Cutter": "HitPaw ऑनलाइन ऑडियो कटर",
  "Trim or cut any audio files online.": "कोई भी ऑडियो फाइल ऑनलाइन ट्रिम करें या काटें।",
  "Cut": "काटें",
  "Fade in": "फेड इन",
  "Fade out": "फेड आउट",
  "Cut from": "से काटें",
  "to": "तक",
  "Extract selection": "चयनित निकालें",
  "Delete selection": "चयनित हटाएं",
  "Adjust New": "नया समायोजित करें",
  "Cut New": "नया काटें",
  "Adjust Volume": "वॉल्यूम समायोजित करें",
  "HitPaw Online Volume Changer": "HitPaw ऑनलाइन वॉल्यूम चेंजर",
  "Turn up or Turn down the volume of audio.": "ऑडियो का वॉल्यूम बढ़ाएं या कम करें।",
  "Volume": "वॉल्यूम",
  "Change Speed": "गति बदलें",
  "HitPaw Online Audio Speed Changer": "HitPaw ऑनलाइन ऑडियो स्पीड चेंजर",
  "Speed up or slow down audios online easily.": "आसानी से ऑनलाइन ऑडियो तेज़ या धीमा करें।",
  "Speed": "गति",
  "Format": "फॉर्मेट",
  "Size": "साइज़",
  "Duration": "अवधि",
};
